export default [
  {
    name: 'Contact Full Name',
    keyword: 'contact_name',
    source: 'contact',
  },
  {
    name: 'Agent First Name',
    keyword: 'agent_first_name',
    source: 'agent',
  },
  {
    name: 'Agent Full Name',
    keyword: 'agent_name',
    source: 'agent',
  },
  {
    name: 'Business Name',
    keyword: 'business_name',
    source: 'merchant',
  },
];
